export const isFilterEmpty = (filter: unknown) => {
  if (!Array.isArray(filter)) return !filter;

  return (
    !filter.length || !filter.some((value) => Boolean(value) || value === 0)
  );
};
